import React from "react";
import Grid from "@mui/material/Grid";

import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import MDButton from "mdComponents/MDButton";

import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Footer from "components/Footer";

import { APP_NAME } from "../../constants";
import { MainLogo } from "../../components/Icons/MainLogo";
import CorporateReportIssue from "../../controls/CorporateReportIssue";
import { Card } from "@mui/material";

const Support = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={4}>
          {/* HEADER */}
            <MDBox textAlign="center" mb={6}>
              <MainLogo style={{ height: 120 }} />
              <MDTypography
                variant="h3"
                fontWeight={700}
                mt={2}
                mb={1}
              >
                Pappa Squat Business User Support
              </MDTypography>
              <MDTypography variant="body1" color="text.secondary">
                Reliable support for confident hosting
              </MDTypography>
            </MDBox>


<Grid container justifyContent="center">
  <Grid item xs={12} md={10} lg={8}>
            <MDBox mb={4}>
              <Card sx={{padding:3}}>
              <MDTypography variant="h4" fontWeight="bold">
                Frequently Asked Questions
              </MDTypography>
              <MDTypography variant="body2" mb={2}>
                Here are some of the most frequently asked questions. For more help, contact us via email or submit an issue below.
              </MDTypography>
              {/* Access & Door Locking */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  What if a user can’t unlock the restroom door?
                </MDTypography>
                <MDTypography variant="body2">
                  First, verify the location’s Door Lock Settings to confirm a lock is required
                  and that the door code is correct. Ensure the location is open and not closed
                  for cleaning. If the issue continues and no one is inside, you may clear the
                  restroom to reset the visit queue.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  What does “Clear Restroom” do?
                </MDTypography>
                <MDTypography variant="body2">
                  Clearing the restroom immediately ends all active or stuck visits for the
                  location. This should only be used when you are certain the restroom is empty.
                  Once cleared, new users can access the location right away.
                </MDTypography>
              </MDBox>

              {/* Visits & Timing */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Why does the app say a user is still inside the restroom?
                </MDTypography>
                <MDTypography variant="body2">
                  This usually happens when a user closes the app or loses connectivity before
                  ending their visit. If the restroom is empty, you can safely use Clear Restroom
                  to resolve the issue.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Can I change how long users are allowed inside?
                </MDTypography>
                <MDTypography variant="body2">
                  Yes. You can update the Time per Visit setting from the location’s Door Lock
                  Settings. Changes apply to all future visits.
                </MDTypography>
              </MDBox>

              {/* Cleaning & Closures */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  What happens when I close a location for cleaning?
                </MDTypography>
                <MDTypography variant="body2">
                  The location will not be removed from the user map but will show as 'Closed for Cleaning' and will not accept new visits.
                  You can reopen it at any time, and it will become available immediately.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Can I close a location for reasons other than cleaning?
                </MDTypography>
                <MDTypography variant="body2">
                  Yes. Locations can be closed for any reason, including maintenance, staffing,
                  or temporary downtime. Closing this way lets users know you are only closed temporarily.
                </MDTypography>
              </MDBox>

              {/* Users & Reports */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  How do poor condition reports work?
                </MDTypography>
                <MDTypography variant="body2">
                  Users can submit poor condition reports shortly after starting a visit.
                  Reports are tied to visit history and help identify cleanliness or misuse
                  issues at a location.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Can I suspend or ban users?
                </MDTypography>
                <MDTypography variant="body2">
                  Yes. You can suspend or permanently ban users from individual locations.
                  Suspended or banned users will no longer see that location on the map and will receive a strike on their account.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Can suspensions or bans be lifted later?
                </MDTypography>
                <MDTypography variant="body2">
                  Yes. Suspensions and bans can be lifted at any time from the location’s
                  user management screen.
                </MDTypography>
              </MDBox>

              {/* Admins & Accounts */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  What’s the difference between Corporate Admins and Location Host Admins?
                </MDTypography>
                <MDTypography variant="body2">
                  Corporate Admins have access to all locations and corporate settings.
                  Location Host Admins only have access to the specific locations you assign. Corporate Admins are able to delete locations, while Location Host Admins are not able to delete locations.
                </MDTypography>
              </MDBox>

              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Do admins need an existing Pappa Squat account?
                </MDTypography>
                <MDTypography variant="body2">
                  Admins are added by email. If they don't already have an account, access will
                  be granted once they sign up using that email address.
                </MDTypography>
              </MDBox>

              {/* Billing & Support */}
              <MDBox mb={3}>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  Where do I manage my hosting plan?
                </MDTypography>
                <MDTypography variant="body2">
                  Hosting plans are selected when adding a location and can be reviewed from the
                  location settings page.
                </MDTypography>
              </MDBox>

              <MDBox>
                <MDTypography variant="subtitle1" fontWeight="medium">
                  What should I report using the support form?
                </MDTypography>
                <MDTypography variant="body2">
                  Use the support form to report app bugs, billing concerns,
                  incorrect data, or anything impacting your ability to host users.
                </MDTypography>
              </MDBox>

              </Card>
            </MDBox>


            {/* Email Support */}
            <MDBox
              p={3}
              mb={6}
              borderRadius="lg"
              sx={{
                backgroundColor: "rgba(0,0,0,0.02)",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <MDTypography variant="h5" fontWeight="bold" mb={1}>
                Still need help?
              </MDTypography>
              <MDTypography variant="body2" color="text" mb={2}>
                If your issue is urgent or you prefer email communication,
                contact our support team directly.
              </MDTypography>
              <MDButton
                variant="gradient"
                color="info"
                component="a"
                target="_blank"
                href={`mailto:admin@mackessoftware.com`}
              >
                Send us an email
              </MDButton>
            </MDBox>
            <CorporateReportIssue />
          </Grid>

        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
};

export default Support;
